import { Button, DatePicker, message, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import moment from "moment";
import dayjs from "dayjs";
import { token } from "../../constants/Constants";
import { get_order_not_accept_report } from "../../endpoints/API";

const WETATFailure = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const { RangePicker } = DatePicker;
  const [data, setData] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);

  useEffect(() => {
    const today = dayjs().format("YYYY-MM-DD");
    setSelectedDates(["", today]);
    fetchReportData(["", today]);
  }, []);

  const fetchReportData = async (dates) => {
    try {
      const response = await get_order_not_accept_report(dates?.[0], dates?.[1]);
      if (response.status !== 200) throw new Error("Network response was not ok");
      const result = response?.data || [];
      const transformed = result.map((order) => {
        const items = order.items || [];
        return {
          ...order,
          patient_name: items.map((i) => i.patient_name).filter(Boolean).join(", "),
          patient_phone: items.map((i) => i.patient_phone).filter(Boolean).join(", "),
          patient_gender: items.map((i) => i.patient_gender).filter(Boolean).join(", "),
          test_id: items.map((i) => i.test_id).filter(Boolean),
          test_name: items.map((i) => i.test_name).filter(Boolean),
          test_amount: items.map((i) => parseFloat(i.test_amount) || 0).reduce((a, b) => a + b, 0),
          b2b_total: items.map((i) => parseFloat(i.b2b_total) || 0).reduce((a, b) => a + b, 0),
          lab: items.map((i) => i.lab).filter(Boolean).join(", "),
        };
      });
      setData(transformed);
    } catch (error) {
      message.error(error?.response?.data?.error || "Error fetching report data:");
    }
  };

  const handleDateChange = (value, dateString) => {
    setSelectedDates(dateString);
    fetchReportData(dateString);
  };

  const formatCSVValue = (value) => {
    if (Array.isArray(value)) return `"${value.join(", ")}"`;
    return `"${value || ""}"`;
  };

  const handleDownload = () => {
    const csvContent = [
      columns.map((col) => col.title).join(","),
      ...data.map((row) =>
        columns.map((col) => {
          let value = row[col.dataIndex];
          if (col.dataIndex === "schedule_date_time" && value)
            return formatCSVValue(moment(value).format("DD/MM/YYYY hh:mm A"));
          return formatCSVValue(value);
        }).join(",")
      ),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "WETatfailureReport.csv";
    link.click();
  };

  const columns = [
    { title: "Order Number", dataIndex: "order_number", key: "order_number", width: 120, fixed: "left" },
    { title: "Placed Date", dataIndex: "place_date", key: "place_date", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Scheduled Date", dataIndex: "schedule_date_time", key: "schedule_date_time", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Accepted Date", dataIndex: "accepted_datetime", key: "accepted_datetime", width: 155, render: (text) => text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-" },
    { title: "Patient Name", dataIndex: "patient_name", key: "patient_name", width: 130 },
    { title: "Patient Gender", dataIndex: "patient_gender", key: "patient_gender", width: 110 },
    { title: "Patient Ph No", dataIndex: "patient_phone", key: "patient_phone", width: 125, render: (text) => text ? `'${text}` : "-" },
    { title: "Test ID", dataIndex: "test_id", key: "test_id", width: 120, render: (text) => Array.isArray(text) ? text.join(", ") : text || "-" },
    { title: "Test Name", dataIndex: "test_name", key: "test_name", width: 150, render: (text) => Array.isArray(text) ? text.join(", ") : text || "-" },
    {
      title: "Test Amount", dataIndex: "test_amount", key: "test_amount", width: 110,
      render: (text) => {
        if (typeof text === "string") {
          const totalAmount = text.split(",").map((num) => parseFloat(num.trim())).reduce((acc, val) => acc + val, 0);
          return totalAmount ? totalAmount : "-";
        }
        return text;
      },
    },
    { title: "Discount", dataIndex: "discount", key: "discount", width: 90 },
    { title: "Wellness Executive", dataIndex: "wellness_executive", key: "wellness_executive", width: 145, render: (text) => text || "-" },
    { title: "Lab Name", dataIndex: "lab", key: "lab", width: 120, render: (text) => text || "-" },
  ];

  return (
    <div style={{ padding: "8px" }}>
      <div className="flex flex-col md:flex-row md:items-center gap-2 mb-2">
        <span className="font-semibold whitespace-nowrap">Total: <Tag>{data?.length}</Tag></span>
        <div className="w-full md:flex-1 md:max-w-xs">
          <RangePicker
            format="YYYY-MM-DD"
            onChange={handleDateChange}
            disabledDate={(current) => current && current > dayjs().endOf("day")}
            style={{ width: "100%" }}
          />
        </div>
        <Button type="primary" onClick={handleDownload} disabled={!data.length} className="w-full md:w-auto">
          Download Report <DownloadOutlined />
        </Button>
      </div>
      <div style={{ overflowX: "auto", marginTop: 16 }}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey={(record, index) => index}
          scroll={{ x: "max-content" }}
          size="small"
          pagination={{ responsive: true }}
        />
      </div>
    </div>
  );
};

export default WETATFailure;